import React from 'react';

const IconLoader = () => (
  <svg id="logo" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100">
    <title>Loader Logo</title>
    <g>
      <g id="H" transform="translate(36.000000, 33.000000)">
        
        <path d="M 22 35 L 22 19.05 L 4.75 19.05 L 4.75 35 L 0 35 L 0 0 L 4.75 0 L 4.75 14.95 L 22 14.95 L 22 0 L 26.75 0 L 26.75 35 L 22 35 Z" fill="currentColor"/>
      </g>
      <path
        stroke="currentColor"
        strokeWidth="5"
        strokeLinecap="round"
        strokeLinejoin="round"
        d="M 50, 5
                  L 11, 27
                  L 11, 72
                  L 50, 95
                  L 89, 73
                  L 89, 28 z"
      />
    </g>
  </svg>
);

export default IconLoader;
